// src/components/ReceiptModal.jsx
import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "../Wallet/ReceiptModal.css"; // Agar custom styling alag rakhni ho
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
// import ShowImagePath from "../../Others/ImportantFunction";
// import { useAuth } from "../../../Store/AuthContext";

export default function LeadTransactionReceiptModal({
  show,
  onClose,
  transaction,
  paid_type_status,
  showBordersStyle,
  showTextStyle,
}) {
  const receiptRef = useRef(null);
  //   const { webSetting } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleDownloadPDF = async () => {
    try {
      setLoading(true); // 👈 loader start
      const element = receiptRef.current;

      const canvas = await html2canvas(element, {
        scale: 2,
        ignoreElements: (el) => el.classList.contains("exclude-pdf"),
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`transaction_${transaction.order_id}.pdf`);
      NotifyMessageNoReload("Download Successfully !", "success");
    } catch (error) {
      console.error("PDF Download Error:", error);
    } finally {
      setLoading(false); // 👈 loader stop
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }

  //   const ImageShowimage = ShowImagePath(
  //     webSetting.file_path,
  //     webSetting.footer_logo
  //   );

  return (
    <div className="receipt-overlay">
      <div className="receipt-modal" ref={receiptRef}>
        {/* Header */}
        <div className="receipt-header">
          <h4>PAYMENT RECEIPT</h4>
          <p>Official Transaction Confirmation</p>
          {/* <div className="sitelogo">
            <img
              src={webSetting.footer_logo && ImageShowimage}
              alt=""
              title=""
              className="moudleLogo"
            />
          </div> */}
          {/* <div className="transactionbox">
            <div className="receipt-row">
              <span>Receipt No.</span>
              <span>{transaction.receipt_no}</span>
            </div>
            <div className="receipt-row">
              <span>Transaction Date</span>
              <span>{transaction.payment_date}</span>
            </div>
          </div> */}
        </div>

        {/* Body */}
        <div className="receipt-body">
          <div className="transactionbox">
            {transaction.receipt_id && (
              <div className="receipt-row">
                <span className="receptFirst">Receipt ID</span>
                <span className="receptSecond">{transaction.receipt_id}</span>
              </div>
            )}
            {transaction.lead_id && (
              <div className="receipt-row">
                <span className="receptFirst">Lead ID</span>
                <span className="receptSecond">{transaction.lead_id}</span>
              </div>
            )}
            <div className="receipt-row">
              <span className="receptFirst">Transacion Date</span>
              <span className="receptSecond"> {transaction.payment_date}</span>
            </div>
          </div>
          <div className="receiptdivider mt-4">
            <span className="divider-text">Transaction Details</span>
          </div>

          <div className="receipt-amount">
            <span className={`transAmount ${showTextStyle}`}>
              {`₹${transaction.amount}`}
            </span>
            {paid_type_status}
          </div>

          {transaction.order_id && (
            <div className="receipt-row">
              <span className="receptFirst">Order ID</span>
              <span className="receptSecond">{transaction.order_id}</span>
            </div>
          )}
          {transaction.transaction_id && (
            <div className="receipt-row">
              <span className="receptFirst">Transaction ID</span>
              <span className="receptSecond">{transaction.transaction_id}</span>
            </div>
          )}

          {transaction.transaction_order_id && (
            <div className="receipt-row">
              <span className="receptFirst">Transaction Order ID</span>
              <span className="receptSecond">
                {transaction.transaction_order_id}
              </span>
            </div>
          )}
          {transaction.seller_user_id && (
            <div className="receipt-row">
              <span className="receptFirst">Seller User ID</span>
              <span className="receptSecond">{transaction.seller_user_id}</span>
            </div>
          )}
          {transaction.account_id && (
            <div className="receipt-row">
              <span className="receptFirst">Account ID</span>
              <span className="receptSecond">{transaction.account_id}</span>
            </div>
          )}
          {transaction.payment_mode && (
            <div className="receipt-row">
              <span className="receptFirst">Payment Method</span>
              <span className="receptSecond">{transaction.payment_mode}</span>
            </div>
          )}

          {transaction.credit_debit && (
            <div className="receipt-row">
              <span className="receptFirst">Payment Staus</span>
              <span
                className={`badge ${
                  transaction.credit_debit === "1" ? "bg-info" : "bg-danger"
                }`}
              >
                {transaction.credit_debit === "1" ? "Credit" : "Debit"}
              </span>
            </div>
          )}

          <div className="receipt-row">
            <span className="receptFirst">Withdrawal Amount</span>
            <span className={`receptSecond ${showTextStyle}`}>
              ₹{transaction.amount}
            </span>
          </div>
          <div className="receipt-row">
            <span className="receptFirst">Status</span>
            <span className="receptSecond"> {paid_type_status}</span>
          </div>
          {transaction.description && (
            <div className="receipt-row">
              <span className="receptFirst">Description</span>
              <span className="receptSecond">{transaction.description}</span>
            </div>
          )}

          <div className="receiptdivider my-4">
            <span className="divider-text">User Information</span>
          </div>

          <div className="receipt-row">
            <span className="receptFirst">Name</span>
            <span className="receptSecond">{transaction.name}</span>
          </div>

          <div className="receipt-row">
            <span className="receptFirst">Mobile Number</span>
            <span className="receptSecond">{transaction.phone}</span>
          </div>

          <div className="receipt-row">
            <span className="receptFirst">Email</span>
            <span className="receptSecond">{transaction.email}</span>
          </div>
          {transaction.address && (
            <div className="receipt-row">
              <span className="receptFirst">Address</span>
              <span className="receptSecond">{transaction.address}</span>
            </div>
          )}

          <div className="receipt-secured">
            <span>🔒 Secured Transaction</span>
            <span>✔ Verified Payment</span>
          </div>
        </div>

        {/* Footer */}
        <div className="receipt-footer">
          <p className="mb-1">Thank you for choosing YourDoorstep</p>
          <span>
            This is a computer generated receipt. No signature required.
            <br />
            For any queries, contact <b>support@yourdoorstep.co</b> or call{" "}
            <b>+91 9540005064</b>
          </span>
        </div>

        {/* Actions */}
        <div className="receipt-actions exclude-pdf">
          <button
            onClick={onClose}
            className="theme-btn btn-style-three submitbtn"
            disabled={loading}
          >
            Close
          </button>
          <button
            onClick={handleDownloadPDF}
            className="btn-download"
            disabled={loading}
          >
            {loading ? "Downloading..." : "Download"}
          </button>
        </div>
      </div>
    </div>
  );
}
